import { FormTemplate } from 'data/template/template.types';

// eslint-disable-next-line import/prefer-default-export
export const snmpDestTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'SNMP Destination',
  key: 'snmpDest',
  main: {
    metadata: {
      layout: {
        rows: [
          ['id'],
          ['NAME', 'VERSION', '$empty'],
          ['DESTIP', 'DESTPORT', '$empty'],
          ['SECURITYNAMEV3', 'SECURITYNAME', 'OWNIP', 'OWNPORT'],
          ['REQSTATE', '$empty', '$empty']
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      DESTID: {
        label: 'Destination Id',
        type: 'number',
        hide: 'true',
        initial: '1',
        validation: {
          validators: [
            {
              type: 'length',
              length: 3
            },
            {
              type: 'Interval',
              intervals: [
                [
                  1,
                  256
                ]
              ],
              errorMessage: 'Must be between 1 - 256. Please re-enter.'
            }
          ]
        }
      },
      NAME: {
        label: 'Name',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 64,
            },
          ],
        }
      },
      VERSION: {
        label: 'Version',
        type: 'select',
        initial: 'SNMPV3',
        options: [
          {
            label: 'SNMPV2C',
            value: 'SNMPV2C'
          },
          {
            label: 'SNMPV3',
            value: 'SNMPV3'
          }
        ]
      },
      SECURITYNAMEV3: {
        label: 'Security Name',
        type: 'select',
        initial: '',
        hintMessage: 'Enter Community string that is configured on the SNMP v2c Trap destination, or Username for SNMP v3',
        options: [
          {
            label: 'Select a user',
            value: ''
          }
        ]
      },
      SECURITYNAME: {
        label: 'Security Name',
        hide: 'true',
        type: 'text',
        initial: '',
        hintMessage: 'Enter Community string that is configured on the SNMP v2c Trap destination, or Username for SNMP v3',
        validation: {
            validators: [
              {
                type: 'length',
                length: 128,
              },
            ],
          }
      },
      DESTIP: {
        label: 'Destination IP',
        type: 'text',
        initial: '',
        validation: {
            required: true,
            validators: [
              {
                type: 'length',
                length: 50
              },
              {
                type: 'IPAddress',
                errorMessage: 'Must be a valid IP Address. Please re-enter.'
              }
            ]
          }
      },
      DESTPORT: {
        label: 'Destination Port',
        type: 'text',
        initial: '162',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 5
            },
            {
              type: 'Interval',
              intervals: [
                [
                  1,
                  65535
                ]
              ],
              errorMessage: 'Must be between 1 - 65535. Please re-enter.'
            }
          ]
        }
      },
      OWNIP: {
        label: 'Own IP',
        type: 'text',
        initial: '0.0.0.0',
        hintMessage: 'If left empty, default value is "0.0.0.0" or "::" based on Dest IP address family',
        validation: {
            validators: [
              {
                type: 'length',
                length: 50
              },
              {
                type: 'IPAddress',
                errorMessage: 'Must be a valid IP Address. Please re-enter.',
                invalidIPs: ['255.255.255.255'],
              }
            ]
          }
      },
      OWNPORT: {
        label: 'Own Port',
        type: 'text',
        initial: '0',
        validation: {
          validators: [
            {
              type: 'length',
              length: 5
            },
            {
              type: 'Interval',
              intervals: [
                [
                  0,
                  65535
                ]
              ],
              errorMessage: 'Must be between 0 - 65535. Please re-enter.'
            }
          ]
        }
      },
      REQSTATE: {
        label: 'Request State',
        type: 'select',
        initial: 'ACTIVE',
        options: [
          {
            label: 'Active',
            value: 'ACTIVE'
          },
          {
            label: 'Inactive',
            value: 'INACTIVE'
          }
        ]
      }
    },
  }
};
